module.exports = __webpack_public_path__ + "img/dp-dy-sh5.6c349362.png";